import './styles/app.less'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixin from '@/mixins'
import config from '@/config'

import './icons' // icon
import './filters'
import './directives'
import './plugins'
import './permission'
import errorHandler from './errorHandler'
import globalComponents from './components'

Vue.config.productionTip = false
Vue.config.errorHandler = errorHandler

// pc/h5 设备跳转：移动端访问 pc 站点，自动跳回 h5 站点首页
function deviceRedirect() {
  const ua = navigator.userAgent
  // 主流移动端 UA 关键字匹配（Mobile 可覆盖微信/钉钉等内置浏览器）
  const uaMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile/i.test(ua)
  // iPadOS 13+ 的 iPad 在 Safari 下 UA 伪装成 Macintosh，需结合触控点判断（触控屏 Mac 一般为 1 点）
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const isMobile = uaMatch || iPadOS
  const domain = config.domain || {}
  if (isMobile && domain.h5) {
    window.location.replace(domain.h5)
  }
}

deviceRedirect()

Object.keys(globalComponents).forEach(name => Vue.component(name, globalComponents[name]))

// mixin
Vue.mixin(mixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
